export const EReInvestmentStrategy = [
    // {id: 1, label: 'Pulverizad'},
    {
        id: 3,
        label: 'Cenário ideal',
        description: 'Mostra o aporte teórico necessário em cada ativo para zerar a diferença até a alocação alvo da carteira.'
    },
    {
        id: 2,
        label: 'Concentrado',
        description: 'Direciona o capital primeiro para os ativos mais defasados e vai avançando até consumir o valor disponível.'
    },
    {
        id: 4,
        label: 'Pulverizado (s/ considerar preço médio)',
        description: 'Distribui o capital entre os ativos elegíveis proporcionalmente à nota atribuída em "Rebalancear Carteira" de cada ativo, sem usar o preço médio como critério de priorização.'
    },
    {
        id: 5,
        label: 'Pulverizado (considerando preço médio )',
        description: 'Distribui o capital proporcionalmente à nota atribuída em "Rebalancear Carteira" e usa o preço médio para influenciar a ordem de prioridade dos ativos.'
    },
     {
        id: 6,
        label: 'Pulverizado (Com auxílio de IA ✨) - Em breve',
        description: 'Distribui o capital proporcionalmente à nota atribuída em "Rebalancear Carteira", com apoio de Inteligência Artificial para refinar a análise e sugerir uma priorização mais inteligente dos ativos.'
    },
]

export default EReInvestmentStrategy;
